module.exports = function getResource(label, vars = []) {
    const resources = {
        zeroResults: 'Désolés, nous n’avons pas trouvé de correspondance pour',
        spellCheck: 'Veuillez vérifier vos termes de recherche et réessayer.'
    };
    return resources[label];
};
